<script>
export default {
  name: 'movieBg',
  components: {
  },
  data() {
    return {
      ready: false,
      complete: false,
      rows: [1, 2, 3, 4, 5],
      cols: [0, 1, 2, 3, 4, 5 ,6]
    };
  },
  props: {
  },
  created() {
    setTimeout(()=> {
      this.ready = true;
    }, 1);
    setTimeout(()=> {
      this.complete = true;
    }, 2200);
  },
  methods: {
    getTransitionDelay() {
      return (Math.random() * 2) + 's';
    },
  }
};
</script>

<template>
  <div class="movie-backGround" :class="[ready ? 'is-ready' : '', complete ? 'is-complete' : '',]">
    <div
      v-for="row in rows"
      :key="`r${row}`"
    >
      <div
        v-for="col in cols"
        :key="`r${row}c${col}`"
        class="tile"
        :class="[`r${row}`, `c${col}`]"
        :style="{'transition-delay': getTransitionDelay()}"
      >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .movie-backGround {
    @include absolute100;
    
    .tile {
      background: $textColorA50;
    }
    .tile{
        height: 20%;
        width: 0%;
        position: absolute;
        transition: 0.2s ease;
        transform: skewX(30deg);
    }
    .r1{top: 0%;}
    .r2{top: 20%;}
    .r3{top: 40%;}
    .r4{top: 60%;}
    .r5{top: 80%;}

    .c0{left: -20%;}
    .c1{left: 0%;}
    .c2{left: 20%;}
    .c3{left: 40%; height: 0%; width: 20%;}
    .c4{right: 20%;}
    .c5{right: 0%;}
    .c6{right: -20%;}
    &.is-ready {
      .c0, .c1, .c2, .c4, .c5, .c6{
        width: 20%;
      }
      .c3 {height: 20%;}
      .tile {
        transform: skewX(-30deg);
      }
    }
    &.is-complete {
      background: $textColorA50;
      .tile{
        display: none;
      }
    }
  }
</style>
